import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import Button from 'toluna-react-components/Inputs/Button';
import styles from './styles.scss'; // eslint-disable-line


class QualMediaBlockContainer extends Component {
  constructor(props) {
	super(props);
	this.displayName = 'QualMediaBlockContainer';

	this.openMediaGallery = this.openMediaGallery.bind(this);
  }

  render() {
	return (
		<div className="qual-media-block-wrapper">
		  <Button
			  styleName="btnCancel"
			  onClick={this.openMediaGallery}
			  buttonStyle={Button.BUTTON_STYLE.CENTERED_CONTENT}
			  text={this.props.mediaButtonLabelStr || 'Media'}
			  small
		  />
		</div>
	);
  }

  openMediaGallery() {
	console.log('opening gallery');
  }
}

QualMediaBlockContainer.propTypes = {
  questionId: PropTypes.string.isRequired
};

QualMediaBlockContainer.defaultProps = {};

export default CSSModules(QualMediaBlockContainer, styles);



// WEBPACK FOOTER //
// ./components/qual/MediaBlock/MediaBlock_container.js